import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userJobsListStatus',
  pure: false
})
export class UserJobsListFilterStatus implements PipeTransform {
  transform(items: any[], filter: number): any {
    if (!items || filter==0) {
        return items;
    }
    return items.filter(item => item.enabled==(filter==1?true:false));
  }
}
